
import Message from "@/message";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "MessageNotification",
  props: {
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
  },
  computed: {
    messageClasses() {
      const styleClasses: string[] = [];
      switch (this.message?.kind) {
        case "warning":
          styleClasses.push("is-warning");
          break;
        case "information":
          styleClasses.push("is-info");
          break;
        case "error":
          styleClasses.push("is-danger");
          break;
        case "success":
          styleClasses.push("is-success");
          break;
      }
      return styleClasses;
    },
  },
});
